export const academicTermsKeys = {
  programAcademicTerms: (programId: number) => ['academic_terms', programId],
  updateProgramAcademicTerm: (programId: number, academicTermId: number) => [
    'academic_terms',
    programId,
    academicTermId,
  ],
}
